import React, {useEffect, useState} from 'react';
import {ExpandLess, ExpandMore} from "@mui/icons-material";

export const CARD = {
    PADDING: {
        NONE: '',
        EXTRA_SMALL: 'padding--xs',
        SMALL: 'padding--s',
        MEDIUM: 'padding--m',
        LARGE: 'padding--l',
        EXTRA_LARGE: 'padding--xl'
    },
    RADIUS: {
        NONE: '',
        TINY: 'tiny-box-radius',
        EXTRA_SMALL: 'extra-small-box-radius',
        SMALL: 'small-box-radius',
        MEDIUM: 'medium-box-radius',
        LARGE: '',
        EXTRA_LARGE: ''
    }

}

const Card = (props) => {
    const {type, boxRadius = CARD.RADIUS.SMALL, rounded = true, padding = CARD.PADDING.MEDIUM, parentExpand = null, className, expandable = false, initExpanded = false, title, children, ...other} = props,
        [expanded, setExpanded] = useState(initExpanded);
    let classes = 'ch-card';
    classes += className ? ' ' + className : '';
    classes += rounded ? ' rounded' : '';

    classes += " "+padding;
    classes += " "+boxRadius;

    const toggleExpand = () => {
        setExpanded(!expanded);
    }

    useEffect(()=>{
        if(parentExpand !== null){
            setExpanded(parentExpand);
        }
    },[parentExpand]);

    if (expandable) {
        if(expandable.aligned === 'left'){
            return(<div
                className={classes}
                {...other}>
                <>
                    <div className={'ch-card-expandable'} onClick={toggleExpand}>
                        <div>
                            {expanded ? <ExpandLess style={{width: '24px', height: '24px'}}/> : <ExpandMore style={{width: '24px', height: '24px'}}/>}
                        </div>
                        <h4>{title}</h4>
                    </div>
                    {expanded &&
                        <div className={"margin-l--l"}>
                            {children}
                        </div>
                    }
                </>
            </div>);
        }else{
            return (
                <div
                    className={classes}
                    {...other}>
                    <>
                        <div className={'ch-card-expandable'} style={{justifyContent: 'space-between'}} onClick={toggleExpand}>
                            <h4>{title}</h4>
                            <div>
                                {expanded ? <ExpandLess style={{width: '24px', height: '24px'}}/> : <ExpandMore style={{width: '24px', height: '24px'}}/>}
                            </div>
                        </div>
                        {expanded &&
                            <>
                                {children}
                            </>
                        }
                    </>
                </div>
            );
        }
    }

    return (
        <div
            className={classes}
            {...other}>
            {children}
        </div>
    );
}

export default Card;
